import { RegisteredComponent } from "@builder.io/sdk-react";

export const generalFormConfig: RegisteredComponent["inputs"] = [
  {
    name: "name",
    type: "string",
    localized: false,
    required: true,
    helperText:
      'Every input in a form needs a unique name describing what it takes, e.g. "email". For radio types of the same group, the same name should be used for all radios of the same group',
  },
  {
    name: "required",
    type: "boolean",
    localized: false,
  },
  {
    name: "disabled",
    type: "boolean",
    localized: false,
  },
];
